import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/logo.png'


const _withScopeId = n => (_pushScopeId("data-v-47f58dab"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "sticky top-0 z-50 flex items-center justify-between px-8 py-2 bg-opacity-50 border-b md:px-24 lg:px-32 xl:px-48 border-primary bg-background" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex items-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "logo",
    class: "w-11 h-11"
  }),
  /*#__PURE__*/_createElementVNode("div", { class: "text-secondary px-2" }, "Louis Blog")
], -1))
const _hoisted_3 = { class: "hidden md:block" }
const _hoisted_4 = { class: "flex items-center" }
const _hoisted_5 = { class: "flex-1 px-4" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("About")
const _hoisted_7 = { class: "flex-1 px-4" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Experience")
const _hoisted_9 = { class: "flex-1 px-4" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Skills")
const _hoisted_11 = { class: "flex-1 px-4" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode("Education")
const _hoisted_13 = { class: "flex-1 px-4" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode("Contact")
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line-menu half start" }, null, -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line-menu" }, null, -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "self-end line-menu half end" }, null, -1))
const _hoisted_18 = [
  _hoisted_15,
  _hoisted_16,
  _hoisted_17
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_CustomRouterLink = _resolveComponent("CustomRouterLink")!
  const _component_MobileMenu = _resolveComponent("MobileMenu")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("header", _hoisted_1, [
      _createVNode(_component_RouterLink, {
        to: { path: '/', hash: '#about' },
        "aria-label": "Logo"
      }, {
        default: _withCtx(() => [
          _hoisted_2
        ]),
        _: 1
      }),
      _createElementVNode("nav", _hoisted_3, [
        _createElementVNode("ul", _hoisted_4, [
          _createElementVNode("li", _hoisted_5, [
            _createVNode(_component_CustomRouterLink, { to: "#about" }, {
              default: _withCtx(() => [
                _hoisted_6
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", _hoisted_7, [
            _createVNode(_component_CustomRouterLink, { to: "#work-experience" }, {
              default: _withCtx(() => [
                _hoisted_8
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", _hoisted_9, [
            _createVNode(_component_CustomRouterLink, { to: "#skills" }, {
              default: _withCtx(() => [
                _hoisted_10
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", _hoisted_11, [
            _createVNode(_component_CustomRouterLink, { to: "#education" }, {
              default: _withCtx(() => [
                _hoisted_12
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", _hoisted_13, [
            _createVNode(_component_CustomRouterLink, { to: "#contact" }, {
              default: _withCtx(() => [
                _hoisted_14
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _createElementVNode("button", {
        class: _normalizeClass(["flex flex-col justify-between cursor-pointer wrapper-menu md:hidden", _ctx.isMenuOpen ? 'open' : '']),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isMenuOpen = !_ctx.isMenuOpen)),
        "aria-label": "Menu"
      }, _hoisted_18, 2)
    ]),
    _createVNode(_component_MobileMenu, {
      isMenuOpen: _ctx.isMenuOpen,
      onCloseMenu: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isMenuOpen = !_ctx.isMenuOpen))
    }, null, 8, ["isMenuOpen"])
  ], 64))
}